import { apiFetchWeb } from "@/hooks/apiFetchWeb"

type LoginData = {
  email: string
  password: string
}

type RegisterData = {
  name: string
  email: string
  password: string
}

type RegisterResponse = {
  customer: {
    id: number
    name: string
    email: string
  }
}

type LoginResponse = {
  customer: {
    id: number
    name: string
    email: string
  }
  token: string
}

export const websiteAuthService = {
  register: async (data: RegisterData) =>
    apiFetchWeb<RegisterResponse>("website/customer/register", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  login: async (data: LoginData) =>
    apiFetchWeb<LoginResponse>("website/customer/login", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  logout: async () =>
    apiFetchWeb("website/customer/logout", {
      method: "POST",
    }),
  profile: async () =>
    apiFetchWeb("website/customer/profile", {
      method: "POST",
    }),
}
